// prettier-ignore
export const countries: string[] = [
'SWITZERLAND',
'GERMANY',
'AUSTRIA',
'GREAT BRITAIN',
'MALDIVES',
'RUSSIAN FEDERATION',
'UNITED ARAB EMIRATES',
'AMERICAN SAMOA',
'ANDORRA',
'ANLA',
'ANGUILLA',
'ANTARCTICA',
'ANTIGUA AND BARBUDA',
'ARGENTINA',
'ARMENIA',
'ARUBA',
'AUSTRALIA',
'AZERBAIJAN',
'BAHAMAS',
'BAHRAIN',
'BANGLADESH',
'BARBADOS',
'BELARUS',
'BELGIUM',
'BELIZE',
'BENIN',
'BERMUDA',
'BHUTAN',
'BOLIVIA, PLURINATIONAL STATE OF',
'BONAIRE, SAINT EUSTATIUS AND SABA',
'BOSNIA AND HERZEVINA',
'BOTSWANA',
'BOUVET ISLAND',
'BRAZIL',
'BRITISH INDIAN OCEAN TERRITORY',
'BRUNEI DARUSSALAM',
'BULGARIA',
'BURKINA FASO',
'BURUNDI',
'CAMBODIA',
'CAMEROON',
'CANADA',
'CAPE VERDE',
'CAYMAN ISLANDS',
'CENTRAL AFRICAN REPUBLIC',
'CHAD',
'CHILE',
'CHINA',
'CHRISTMAS ISLAND',
'COCOS(KEELING) ISLANDS',
'COLOMBIA',
'COMOROS',
'CON',
'CON, THE DEMOCRATIC REPUBLIC OF THE',
'COOK ISLANDS',
'COSTA RICA',
`COTE D'IVOIRE`,
'CROATIA',
'CUBA',
'CURACAO',
'CYPRUS',
'CZECH REPUBLIC',
'DENMARK',
'DJIBOUTI',
'DOMINICA',
'DOMINICAN REPUBLIC',
'ECUADOR',
'EGYPT',
'EL SALVADOR',
'EQUATORIAL GUINEA',
'ERITREA',
'ESTONIA',
'ETHIOPIA',
'FALKLAND ISLANDS(MALVINAS)',
'FAROE ISLANDS',
'FIJI',
'FINLAND',
'FRANCE',
'FRENCH GUIANA',
'FRENCH POLYNESIA',
'FRENCH SOUTHERN TERRITORIES',
'GABON',
'GAMBIA',
'GEORGIA',
'GHANA',
'GIBRALTAR',
'GREECE',
'GREENLAND',
'GRENADA',
'GUADELOUPE',
'GUAM',
'GUATEMALA',
'GUERNSEY',
'GUINEA',
'GUINEA - BISSAU',
'GUYANA',
'HAITI',
'HEARD ISLAND AND MCDONALD ISLANDS',
'HOLY SEE(VATICAN CITY STATE)',
'HONDURAS',
'HONG KONG',
'HUNGARY',
'ICELAND',
'INDIA',
'INDONESIA',
'IRAN(ISLAMIC REPUBLIC OF)',
'IRAQ',
'IRELAND',
'ISLE OF MAN',
'ISRAEL',
'ITALY',
'JAMAICA',
'JAPAN',
'JERSEY',
'JORDAN',
'KAZAKHSTAN',
'KENYA',
'KIRIBATI',
`KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF`,
'KOREA, REPUBLIC OF',
'KUWAIT',
'KYRGYZSTAN',
`LAO PEOPLE'S DEMOCRATIC REPUBLIC`,
'LATVIA',
'LEBANON',
'LESOTHO',
'LIBERIA',
'LIBYAN ARAB JAMAHIRIYA',
'LIECHTENSTEIN',
'LITHUANIA',
'LUXEMBOURG',
'MACAO',
'MACEDONIA, THE FORMER YUSLAV REPUBLIC OF',
'MADAGASCAR',
'MALAWI',
'MALAYSIA',
'ALAND ISLANDS',
'MALI',
'MALTA',
'MARSHALL ISLANDS',
'MARTINIQUE',
'MAURITANIA',
'MAURITIUS',
'MAYOTTE',
'MEXICO',
'MICRONESIA, FEDERATED STATES OF',
'MOLDOVA, REPUBLIC OF',
'MONACO',
'MONLIA',
'MONTENEGRO',
'MONTSERRAT',
'MOROCCO',
'MOZAMBIQUE',
'MYANMAR',
'NAMIBIA',
'NAURU',
'NEPAL',
'NETHERLANDS',
'NEW CALEDONIA',
'NEW ZEALAND',
'NICARAGUA',
'NIGER',
'NIGERIA',
'NIUE',
'NORFOLK ISLAND',
'NORTHERN MARIANA ISLANDS',
'NORWAY',
'OMAN',
'PAKISTAN',
'PALAU',
'PALESTINIAN TERRITORY, OCCUPIED',
'PANAMA',
'PAPUA NEW GUINEA',
'PARAGUAY',
'PERU',
'PHILIPPINES',
'PITCAIRN',
'POLAND',
'PORTUGAL',
'PUERTO RICO',
'QATAR',
'REUNION',
'ROMANIA',
'ALBANIA',
'RWANDA',
'SAINT BARTHELEMY',
'SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA',
'SAINT KITTS AND NEVIS',
'SAINT LUCIA',
'SAINT MARTIN(FRENCH PART)',
'SAINT PIERRE AND MIQUELON',
'SAINT VINCENT AND THE GRENADINES',
'SAMOA',
'SAN MARINO',
'SAO TOME AND PRINCIPE',
'SAUDI ARABIA',
'SENEGAL',
'SERBIA',
'SEYCHELLES',
'SIERRA LEONE',
'SINGAPORE',
'SINT MAARTEN(DUTCH PART)',
'SLOVAKIA',
'SLOVENIA',
'SOLOMON ISLANDS',
'SOMALIA',
'SOUTH AFRICA',
'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS',
'SPAIN',
'SRI LANKA',
'SUDAN',
'SURINAME',
'SVALBARD AND JAN MAYEN',
'SWAZILAND',
'SWEDEN',
'SYRIAN ARAB REPUBLIC',
'TAIWAN, PROVINCE OF CHINA',
'TAJIKISTAN',
'TANZANIA, UNITED REPUBLIC OF',
'THAILAND',
'TIMOR - LESTE',
'TO',
'TOKELAU',
'TONGA',
'TRINIDAD AND TOBA',
'TUNISIA',
'TURKEY',
'TURKMENISTAN',
'TURKS AND CAICOS ISLANDS',
'TUVALU',
'UGANDA',
'UKRAINE',
'ALGERIA',
'AFGHANISTAN',
'UNITED STATES',
'UNITED STATES MINOR OUTLYING ISLANDS',
'URUGUAY',
'UZBEKISTAN',
'VANUATU',
'VENEZUELA, BOLIVARIAN REPUBLIC OF',
'VIET NAM',
'VIRGIN ISLANDS(BRITISH)',
'VIRGIN ISLANDS(U.S.)',
'WALLIS AND FUTUNA',
'WESTERN SAHARA',
'YEMEN',
'YUSLAVIA',
'ZAMBIA',
'ZIMBABWE',
]
